import {
  ApplicationConfig,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { authInterceptor } from './auth.interceptor';
import { FlagBasedPreloadingStrategy } from './FlagBasedPreloadingStrategy';
import { appHeaderInterceptor } from './app-header.interceptor';
import { provideUiTour } from 'ngx-ui-tour-md-menu';
import { provideApiConfiguration } from '../../api-gen/gen/api-configuration';
import { provideApiConfiguration as provideApiConfigurationServer } from '../../api-gen/gen-server/api-configuration';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(FlagBasedPreloadingStrategy),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideUiTour({}),
    provideHttpClient(
      withInterceptors([authInterceptor, appHeaderInterceptor]),
    ),
    provideApiConfiguration(environment.apiUrl),
    provideApiConfigurationServer(environment.apiUrlServer),
    // Transfer cache stays enabled for all anonymous GETs: endpoints fetched
    // during SSR/prerendering must replay synchronously during hydration so
    // the client's first render matches the server HTML (no flicker, no
    // NG05xx hydration errors). Trade-off: prerendered pages (e.g. home
    // promos) show build-time data until the next in-app fetch or deploy.
    // Requests with auth headers are excluded by Angular's defaults.
    provideClientHydration(
      // Replays user interactions (clicks etc.) that happen before hydration
      withEventReplay(),
    ),
  ],
};
